import '../../utils/assertions.es.js';
import 'react';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import { color, fontSize, lineHeight } from '../../utils/theme.es.js';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import styled from 'styled-components';
import { Box } from '../../primitives/Box/Box.es.js';

const Link = styled(Box)`
    color: ${({ contrast }) => contrast ? color(`text.${contrast}`) : "inherit"};
    font-size: ${({ size }) => size ? fontSize(size) : "inherit"};
    line-height: ${({ size }) => size ? lineHeight(size) : "inherit"};
    text-decoration: underline;

    &:hover {
        cursor: pointer;
    }

    &:hover,
    &:visited {
        text-decoration: none;
    }
`;
const Styled = {
  Link
};

export { Styled };
//# sourceMappingURL=styled.es.js.map
